// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import axios from 'axios'
import { getSessionToken } from './auth'

export const getSecureImage = async (src: string | URL | Request) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        const data = await fetch(src, {
            method: 'GET',
            headers: {
                'X-Session-Token': token,
            },
        })
            .then((response) => response.blob())
            .then((blob) => ({
                localUrl: URL.createObjectURL(blob),
                size: blob.size,
            }))
            .catch((err) => console.error(err))
        return data
    } catch (error) {
        if (error instanceof Error) {
            return error
        }
        return new Error(`[getSecureImage] Error ${error}`)
    }
}

export const getSecureDocument = async (url: string | URL | Request) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        const data = await fetch(url, {
            method: 'GET',
            headers: {
                'X-Session-Token': token,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    return response.blob()
                }
                let message = `[getSecureDocument] Error catched while fetching document | status : ${response.status}`
                const jsonResponse = await response.json()
                if (jsonResponse && Object.prototype.hasOwnProperty.call(jsonResponse, 'message')) {
                    message = jsonResponse.message
                }
                throw new Error(message)
            })
            .then((blob) => URL.createObjectURL(blob))
            .catch((err) => {
                console.error(`[getSecureDocument] Error catched | message : ${err.message}`)
                return new Error('Impossible de récupérer le document')
            })
        return data
    } catch (error) {
        if (error instanceof Error) {
            return error
        }
        return new Error(`[getSecureDocument] Error ${error}`)
    }
}
/**
 * @description will ask a password reset mail
 * @param {String} email
 */
export const requestPasswordReset = async (email: string) => {
    try {
        const response = await fetch(`${window._env_.REACT_APP_HDS_HOST}/login/passwordReset`, {
            method: 'POST',
            body: JSON.stringify({
                email,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
        return response.body
    } catch (error) {
        if (error instanceof Error) {
            return error
        }
        return new Error('Something went wrong')
    }
}

export const getHdsRequester = async () => {
    const sessionToken = await getSessionToken()

    const requester = axios.create({
        baseURL: window._env_.REACT_APP_HDS_HOST,
        headers: {
            'X-Session-Token': sessionToken,
        },
        withCredentials: true,
    })

    return requester
}
